import jQuery from "jquery";
let map, popup, Popup;

const mapStyle = [
	{
	  "featureType": "landscape.man_made",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "lightness": 40
		}
	  ]
	},
	{
	  "featureType": "landscape.man_made",
	  "elementType": "geometry.stroke",
	  "stylers": [
		{
		  "color": "#b0b0b0"
		},
		{
		  "weight": 3.5
		}
	  ]
	},
	{
	  "featureType": "poi.business",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "poi.medical",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "poi.school",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "road.arterial",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "color": "#e6f1e4"
		}
	  ]
	},
	{
	  "featureType": "road.arterial",
	  "elementType": "geometry.stroke",
	  "stylers": [
		{
		  "color": "#8c8c8c"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "color": "#b9dbe4"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "geometry.stroke",
	  "stylers": [
		{
		  "color": "#869183"
		}
	  ]
	}
  ];


function _initMap(elem, options) {

	let map = new google.maps.Map(elem, {
		mapId: "839c03fc8b70d7",
		center: {
			lat: options.lat,
			lng: options.lng
		},
		zoom: 16,
		mapTypeControl: false,
		mapTypeControlOptions: {
			mapTypeIds: ["roadmap", "styled_map"]
		}
	}); 

	const marker = new google.maps.Marker({
		position: {
			lat: options.lat,
			lng: options.lng
		},
		map: map
	});

	class Popup extends google.maps.OverlayView {
		position;
		containerDiv;
		constructor(position, content) {
		  super();
		  this.position = position;
		  content.classList.add("popup-bubble");
	
		  // This zero-height div is positioned at the bottom of the bubble.
		  const bubbleAnchor = document.createElement("div");
	
		  bubbleAnchor.classList.add("popup-bubble-anchor");
		  bubbleAnchor.appendChild(content);
		  // This zero-height div is positioned at the bottom of the tip.
		  this.containerDiv = document.createElement("div");
		  this.containerDiv.classList.add("popup-container");
		  this.containerDiv.appendChild(bubbleAnchor);
		  // Optionally stop clicks, etc., from bubbling up to the map.
		  Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
		}
		/** Called when the popup is added to the map. */
		onAdd() {
		  this.getPanes().floatPane.appendChild(this.containerDiv);
		}
		/** Called when the popup is removed from the map. */
		onRemove() {
		  if (this.containerDiv.parentElement) {
			this.containerDiv.parentElement.removeChild(this.containerDiv);
		  }
		}
		/** Called each frame when the popup needs to draw itself. */
		draw() {
		  const divPosition = this.getProjection().fromLatLngToDivPixel(
			this.position,
		  );
		  // Hide the popup when it is far out of view.
		  const display =
			Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
			  ? "block"
			  : "none";
	
		  if (display === "block") {
			this.containerDiv.style.left = divPosition.x + "px";
			this.containerDiv.style.top = divPosition.y + "px";
		  }
	
		  if (this.containerDiv.style.display !== display) {
			this.containerDiv.style.display = display;
		  }
		}
	  }
	
	  popup = new Popup(
		new google.maps.LatLng(options.lat, options.lng),
		document.getElementById("content"),
	  );
	  popup.setMap(map);

	window.mapInitialized = 1;
}

window.initMap = () => {
	if (!jQuery('main.contact').length)
		return;
	
	let mapelem_one = document.getElementById("map");

	_initMap(mapelem_one, {
		lat: 40.6017848,
		lng: 22.9684929
	})
}
